import { TemplatePage } from './types';

const liveStreamSmdSummitTheme: TemplatePage = {
  header: {
    color: '#FAC8E5',
    icon: 'images/video-templates/summit_theme.jpg',
    title: 'Live Stream Templates — SMD Summit Theme',
    title_meta: '10+ Free Live Stream Overlay Templates — SMD Summit Theme',
    description_meta:
      'Make a perfect design for your online conference with Wave.video’s SMD-Summit-themed templates. ' +
      'The set contains free transition screens, overlays, and frames.',
    description:
      'Create bright and memorable design for your online conference with Wave.video’s SMD-Summit-themed ' +
      'templates. You will get a set of pre-designed thumbnails, intros, overlays, transition screens, and more. ' +
      'Wow your attendees at ease!'
  },
  footer: {
    category: 'Live streaming SMD summit theme',
    description:
      'With Wave.video’s themed collections of editable templates, you will impress the attendees of your ' +
      'online conference with no design team! Pick a set of templates that includes thumbnails, countdown, intro ' +
      '& outros, overlays, transition screens, and promo videos and make your event shine. All you need to do is to ' +
      'change the color palette, titles, dates, and names - and you’re all set! Make a conference that everyone will ' +
      'be talking about for a long time.'
  },
  content: [
    {
      type: 'templates',
      title: 'Live streaming SMD summit theme',
      search: { name: 'SMDSummitTheme', tags: 'SMDSummitTheme' }
    },
    { type: 'calendar' }
  ]
};

export default liveStreamSmdSummitTheme;
